import styled from "styled-components";

import { T_TITLE_1 } from "../../global.style";


export const Heading = styled.h3`
    ${T_TITLE_1};
    color: ${props => props.theme.C_TEXT_dialogue};
    margin-bottom: 75px;
`;